module.exports = __webpack_public_path__ + "static/media/dreamgarage.438d8231.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/dreamgarage.mp4
// module id = 408
// module chunks = 0